

import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import SideNav from "./SideNav";
import TopBar from "./TopBar";
import Swal from 'sweetalert2';
import UserContext from './UserContext';
import moment from 'moment';
import {Link, useParams, useNavigate} from "react-router-dom";
import { Modal, Button, Form } from 'react-bootstrap'; 
import QRCode from 'qrcode';
import dayjs from "dayjs";

function ViewAllBookings() {

    const [holiday, setHoliday] = useState([]);

    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);

    const [error_list, setErrorList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const userContext = useContext(UserContext);

  
    const [selectedGame, setSelectedGame] = useState('');
    const [team, setTeam] = useState([]);
    const [selectedGameLocation, setSelectedGameLocation] = useState('');

 
    const [game_available, setGame_available] = useState([]);
    const [bookingDetails, setBookingDetails] = useState({});
    const [view, setView] = ('form');
     const [game_types, setGame_types] = useState([]);

    const [filteredLocations, setFilteredLocations] = useState([]);
      const [selectedStaff, setSelectedStaff] = useState(''); 
    const [selectedGameType, setSelectedGameType] = useState('');
const [startIndex, setStartIndex] = useState(0);
const itemsPerPage = 10; 
  
const today = new Date().toISOString().split('T')[0]; // Current date in YYYY-MM-DD format

const [selectedDate, setSelectedDate] = useState(() => {
  const today = new Date();
  return  today.toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});
});
const [selectedStartTime, setSelectedStartTime] = useState('');
const [selectedEndTime, setSelectedEndTime] = useState('');
const [timeSlotDetails, setTimeSlotDetails] = useState([]);
const [bookingAvailableTimeSlots, setBookingAvailableTimeSlots] = useState([]);
const [disabledTimeSlots, setDisabledTimeSlots] = useState([]);
const [availableSpaces, setAvailableSpaces] = useState({});
const [availableGameTypes, setAvailableGameTypes] = useState([]);
const [timeSlotLoading, setTimeSlotLoading] = useState(false);
const [game_types_array, setGame_types_array] = useState([]);
const [booking_time, setBooking_time] = useState('');

//const filteredEvents = events.filter(event => event.start >= today);

const filteredEvents = events;

const visibleCourts = availableGameTypes.slice(startIndex, startIndex + itemsPerPage);


    const showToast = (message) => {
        Swal.fire({
            icon: 'success',
            title: message,
            color: "white",
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3500,
            customClass: {
                popup: 'sweetalert-popup',
                title: 'sweetalert-title',
                icon: 'sweetalert-icon',
            },
            background: '#333',
            showCloseButton: true,
            padding: '4px',
        });
    };

const timeToMinutes = (timeStr) => {
  const [time, modifier] = timeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;
  return hours * 60 + minutes;
};


    useEffect(() => {
        if (userContext.username) {
            getLocationByUser();
        }
    }, [userContext.username]); 

   
  
    
    async function getLocationByUser() {
        setIsLoading(true);
        try {
            const res = await axios.get(`${API_URL}/view-team-member-by-username/${userContext.username}`);
            if (res.data.status === 200) {
                const filtered = res.data.locations;
                setFilteredLocations(filtered);
    
                if (filtered.length > 0) {
                    const defaultLocation = filtered[0].id;
                    //setSelectedGameLocation('all')
                     setSelectedGameLocation(defaultLocation);
                      fetchGameAvailable(defaultLocation);
                 
                     
                }

                setSelectedStaff('all');
            } else if (res.data.status === 404) {
                // Handle 404 status if needed
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error fetching locations:", error);
        } 
    
    }


    useEffect(() => {
        getTeamList();
    }, []);

     function getTeamList()
        {    
         
        axios.get(`${API_URL}/view-team-members`).then(res=>{
              if(res.data.status === 200){
                  setTeam(res.data.team);       
              }     
              else if(res.data.status === 404){
                setTeam([]);
                 // setMessage(res.data.message);     
                  }             
           });    
        }

    useEffect(() => {
       
  
        if (selectedGameLocation && selectedGame && selectedStaff) {
            setIsLoading(true);
            fetchEvents();
              
            if (selectedGameLocation === "all") {
      // Parse and combine holidays from all locations
      const allHolidays = filteredLocations.flatMap(loc => {
        try {
          return JSON.parse(loc.holiday_details || "[]");
        } catch (e) {
          console.error("Invalid holiday JSON for location:", loc, e);
          return [];
        }
      });

   
      setHoliday(allHolidays);
     
    } else {
      const selectedLocationData = filteredLocations.find(
        (loc) => loc.id === Number(selectedGameLocation)
      );
      if (selectedLocationData) {
        setHoliday(selectedLocationData.holiday_details);
      } else {
        setHoliday([]);
      }
    }
        }
    }, [selectedGameLocation, selectedGame, selectedStaff]);

  
useEffect(() => {

        if (selectedGame && selectedGameLocation ) {
            fetchGameTypes(selectedGame, selectedGameLocation);
        }

    }, [selectedGame, selectedGameLocation]);



    const calculateTimeSlots = (startTime, endTime, interval) => {
        const timeSlots = [];
        const [startHour, startMinute] = parseTime(startTime);
        const [endHour, endMinute] = parseTime(endTime);

        let current = new Date();
        current.setHours(startHour, startMinute, 0, 0);

        const end = new Date();
        end.setHours(endHour, endMinute, 0, 0);

        while (current <= end) {
            const timeSlot = current.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
            timeSlots.push(timeSlot);
            current.setMinutes(current.getMinutes() + interval);
        }

        return timeSlots;
    };


    const parseTime = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':').map(Number);
        const adjustedHours = period === 'PM' && hours !== 12 ? hours + 12 : hours;
        return [adjustedHours, minutes];
    };

 const fetchGameTypes = async (selectedGame, selectedGameLocation) => {

        try {
            const response = await axios.get(`${API_URL}/view-game-type-by-gameId/${selectedGame}/${selectedGameLocation}`);
            if (response.data.gameType) {
                setGame_types(response.data.gameType);
            }
            else {
                setGame_types([]);
            }



        } catch (error) {
            console.error("Error fetching games:", error);

        }
    }

     const fetchTimeSlots = async (gameTypeId) => {
        setTimeSlotLoading(true);
            try {
             
                const response = await axios.get(`${API_URL}/fetch-time-slots`, {
                    params: {
                        location_id: selectedGameLocation,
                        game_id: selectedGame,
                        game_type_id: gameTypeId,
                        selected_date: selectedDate,
                        created_by: userContext.userDetails.id,
                    }
                    
                });
                //   setTimeSlotDetails(prevState => ({
                //     ...prevState,
                //     [selectedGameType]: response.data // Assuming the response is an array with one object for the selected game type
                //   }));
    
    
                setTimeSlotDetails(response.data);
           
              
                const timeSlot = response.data;
    
                const { start_time, end_time, time_slot_interval } = timeSlot;
                const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
                const formattedTimeSlots = formatTimeSlots(timeSlots);
    
    
                //   console.log('Generated Time Slots:', timeSlots);
                const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots`, {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    game_type_id: gameTypeId,
                    selected_date: selectedDate,
                    generated_time_slots: formattedTimeSlots,
                    no_of_adults: 10,
                    no_of_children: 0,
                });
    
                const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
    
                setTimeSlotDetails(timeSlot);
                setBookingAvailableTimeSlots(formattedTimeSlots);
                setDisabledTimeSlots(disabledTimeSlots);
                // console.log(formattedTimeSlots)
                setAvailableSpaces(availableSpaces);
            
    
                await new Promise(resolve => setTimeout(resolve, 300));
    
               //  console.log('Fetched Data:', comparisonResponse.data);
    
            } catch (error) {
                console.error('Error fetching data:', error);
    
            }
           setTimeSlotLoading(false);
        }

         const formatTimeSlots = (timeSlots) => {
        const formattedSlots = [];

        for (let i = 0; i < timeSlots.length - 1; i++) {
            const startTime = timeSlots[i];
            const endTime = timeSlots[i + 1];

            // Convert to 12-hour format
            const startTime12h = convertTo12HourFormat(startTime);
            const endTime12h = convertTo12HourFormat(endTime);

            // Format the range
            const formattedRange = `${startTime12h} - ${endTime12h}`;
            formattedSlots.push(formattedRange);
        }

        return formattedSlots;
    };

    // Function to convert 24-hour time to 12-hour format
    const convertTo12HourFormat = (time24h) => {
        const [hours, minutes] = time24h.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 === 0) {
            hours12 = 12;
        } else if (hours12 === 12) {
            period = 'PM';
        } else if (hours12 > 12) {
            hours12 -= 12;
            period = 'PM';
        }

        return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
    };

    
        useEffect(() => {
      
            if (selectedGameType ) {
                //setIsLoading(true);
                fetchGameTypesArray();
                //setIsLoading(false);
            }
        }, [selectedGameType]);

     const fetchGameTypesArray = async () => {
            try {
                const response = await axios.get(`${API_URL}/view-game-type`);
    
                setGame_types_array(response.data.gameType);
               // setIsLoading(false);
         
               
            } catch (error) {
                //setIsLoading(false);
                console.error("Error fetching games:", error);
    
            }
           
        };
    

    const getHolidayEvents = () => {

        
            let holidayDetails = [];
    
        
            if (typeof holiday === 'string') {
                try {
                    holidayDetails = JSON.parse(holiday); // Parse if it's a JSON string
                } catch (e) {
                    console.error('Invalid JSON format:', e);
                    return false; // Return false if parsing fails
                }
            } else if (Array.isArray(holiday)) {
                holidayDetails = holiday; // If it's already an array
            }
            if (!holidayDetails) return [];
        
            return holidayDetails.flatMap((holidayItem) => {
               const events = [];
                const start = new Date(holidayItem.holiday_from);
                const end = holidayItem.holiday_to ? new Date(holidayItem.holiday_to) : new Date(holidayItem.holiday_from);
              
    const isFullDay =
                start.getHours() === 0 &&
                start.getMinutes() === 0 &&
                end.getHours() === 23 &&
                end.getMinutes() === 59;
    
            if (isFullDay) {
                // Loop through each day for full-day holidays
                const current = new Date(start);
                while (current <= end) {
                    events.push({
                        title: holidayItem.name || 'Holiday',
                        start: new Date(current),
                        allDay: true,
                        description: holidayItem.description,
                        color: '#f44336',
                        backgroundColor: '#9c27b0',
                        borderColor: '#9c27b0',
                        textColor: '#FFFFFF',
                        disabled: true,
                        extendedProps: {
                            isHoliday: true,
                            description: holidayItem.description,
                        },
                    });
                    current.setDate(current.getDate() + 1);
                }
            } else {
                // One single timed event (no loop)
                events.push({
                    title: holidayItem.name || 'Holiday',
                    start: start,
                    end: end,
                    allDay: false,
                    description: holidayItem.description,
                    color: '#f44336',
                    backgroundColor: '#9c27b0',
                    borderColor: '#9c27b0',
                    textColor: '#FFFFFF',
                    disabled: true,
                    extendedProps: {
                        isHoliday: true,
                        description: holidayItem.description,
                    },
                });
            }
    return events;
    
            });
        };
        
        const isHoliday = (dateStr) => {
            let holidayDetails = [];
        
            if (typeof holiday === 'string') {
                try {
                    holidayDetails = JSON.parse(holiday);
                } catch (e) {
                    console.error('Invalid JSON format for holiday:', e);
                    return false;
                }
            } else if (Array.isArray(holiday)) {
                holidayDetails = holiday;
            }
       
             const dateTimeToCheck = moment(dateStr); // full datetime (not just date)
    
                return holidayDetails.some(holidayItem => {
            const from = moment(holidayItem.holiday_from);
            const to = holidayItem.holiday_to
                ? moment(holidayItem.holiday_to)
                : from;
    
      const dayStart = moment(dateStr).startOf('day');  // 00:00
      const dayEnd = moment(dateStr).endOf('day').seconds(0).milliseconds(0);  // 23:59:00
    
        // Only disable if holiday covers entire day exactly or beyond
        return from.isSameOrBefore(dayStart) && to.isSameOrAfter(dayEnd);
    
    
        
            });
            
    
        };
        
      
    

    const handleViewBookings = (bookingId) => {
        navigate('/booking-details/'+bookingId);      
      };


    function fetchGameAvailable(locationId) {
       // setIsLoading(true); // Start loader for game fetching
        axios.get(`${API_URL}/view-available-game-by-locationId/${locationId}`)
            .then(res => {
                if (res.data.games) {
                    setGame_available(res.data.games);
                    if (res.data.games.length > 0) {
                        setSelectedGame(res.data.games[0].id);
                    } else {
                        setSelectedGame('');
                    }
                } else {
                    setGame_available([]);
                }
            })
            .catch(error => {
                console.error("Error fetching games:", error);
            })
           
    }

    function fetchAllLocationGameAvailable(locationIds) {
        // setIsLoading(true); // Start loader for game fetching
        const locationIdsString = locationIds.join(','); // Convert array to comma-separated string
    
        axios.get(`${API_URL}/view-available-game-by-locationIds/${locationIdsString}`)
            .then(res => {
                if (res.data.games) {
                    setGame_available(res.data.games);
                    if (res.data.games.length > 0) {
                        setSelectedGame(res.data.games[0].id);
                    } else {
                        setSelectedGame('');
                    }
                } else {
                    setGame_available([]);
                }
                // setIsLoading(false); // Stop loader for game fetching
            })
            .catch(error => {
                console.error("Error fetching games:", error);
                // setIsLoading(false); // Stop loader for game fetching
            });
    }

    const handleGameChange = (e) => {
        const selectedGameId = e.target.value;
        setSelectedGame(selectedGameId);
    };


    const handleGameAvailableLocationChange = (e) => {
        const selectedGameLocationId = e.target.value;
        setSelectedGameLocation(selectedGameLocationId);
       
        if(selectedGameLocationId == "all")
        {
            const locationIds = filteredLocations.map(location => location.id);
            fetchAllLocationGameAvailable(locationIds);
        }
        else{
            fetchGameAvailable(selectedGameLocationId);
        }
    };

const filterAvailableGameTypes = async () => {
  try {
    const response = await axios.get(`${API_URL}/view-booked-slots/${selectedGameLocation}/${selectedGame}`);
    const bookedSlots = response.data.bookedSlots;


    const selectedStart = timeToMinutes(selectedStartTime);
    const selectedEnd = timeToMinutes(selectedEndTime);

    const unavailableGameTypeIds = new Set();

    bookedSlots.forEach((slot) => {
      if (slot.booked_date === selectedDate) {
        const times = JSON.parse(slot.booked_time); // ["04:00 PM - 05:00 PM"]

        times.forEach((range) => {
          const [bookedStart, bookedEnd] = range.split(' - ');
          const bookedStartMin = timeToMinutes(bookedStart);
          const bookedEndMin = timeToMinutes(bookedEnd);

          const isOverlap = selectedStart < bookedEndMin && selectedEnd > bookedStartMin;
          if (isOverlap) {
            unavailableGameTypeIds.add(slot.game_type_id);
          }
        });
      }
    });

    const filtered = game_types.filter(gt => !unavailableGameTypeIds.has(gt.id));
    setAvailableGameTypes(filtered);
    
    
  } catch (err) {
    console.error("Error filtering game types:", err);
  }
};

useEffect(() => {
  if (game_types.length > 0 && selectedGame && selectedGameLocation && selectedDate ) {
    filterAvailableGameTypes();
    setSelectedGameType(null); 
  }
}, [selectedGame, selectedGameLocation, selectedDate, selectedStartTime, selectedEndTime,game_types]);


    
const handleStaffChange = (e) => {
    const selectedStaffId = e.target.value;
    setSelectedStaff(selectedStaffId);
    
  }

    // const locationColors = {
    //     "Stouffville": "#FF5733", // Example location name and color
    //     "Scarborough": "#006400",
    //     "Ajax": "#3357FF",
    //     // Add more locations and colors as needed
    // };



    function assignColorsToLocations(filteredLocations) {
        const predefinedColors = ["#1c9980", "#006400", "#3357FF", "#4B0082", "#FF1493", "#915006"]; // Your predefined colors
        const locationColors = {};
    
        filteredLocations.forEach((location, index) => {
            locationColors[location.location_name.trim()] = predefinedColors[index % predefinedColors.length];
        });
    
        return locationColors;
    }

    
    const locationColors = assignColorsToLocations(filteredLocations);



    function fetchEvents() {

        const filteredLocationIds = filteredLocations.map(loc => loc.id);
         
        axios.get(`${API_URL}/view-booked-slots-calender/${selectedGameLocation}/${selectedGame}/${selectedStaff}`, {
            params: {
                filtered_location_ids: filteredLocationIds
            }
        }).then(res => {

            if (res.data.status === 200) {

                const formattedEvents = res.data.bookedSlots.map(slot => {
                    const bookingTimes = Array.isArray(slot.booked_time) ? slot.booked_time : JSON.parse(slot.booked_time);
                    // const startTime = new Date(`${slot.booked_date} ${bookingTimes[0].split(' - ')[0]}`);
                    // const endTime = new Date(`${slot.booked_date} ${bookingTimes[bookingTimes.length - 1].split(' - ')[1]}`);

                    const startTime = moment(`${slot.booked_date} ${bookingTimes[0].split(' - ')[0]}`, 'YYYY-MM-DD h:mm A');
                    const endTime = moment(`${slot.booked_date} ${bookingTimes[bookingTimes.length - 1].split(' - ')[1]}`, 'YYYY-MM-DD h:mm A');

                    // Format times
                    const startFormatted = startTime.format('h:mm A');
                    const endFormatted = endTime.format('h:mm A');

                    // const typeOrPackageName = slot.game_type_name ? slot.game_type_name : slot.package_name;
                    
                    const locationShort = slot.location_name.substring(0, 3);
                    const typeOrPackageName = slot.game_type_name ? slot.game_type_name : slot.package_name;
                    // const typeOrPackageShort = typeOrPackageName.substring(0, 3);
                    const typeOrPackageShort = typeOrPackageName ? typeOrPackageName.substring(0, 3) : "";



                    const className = typeOrPackageName === 'Birthday' ? 'birthday-event' : '';
                 const eventColor = locationColors[slot.location_name] || '#000000'; // Default color if location not found

                 
                   const isSameDay = slot.is_same_day === 1;
                    const formattedEvent = {
                        // title: `${slot.location_name} - ${typeOrPackageName} - Adults: ${slot.no_of_adults}, Kids: ${slot.no_of_children}`,
                        title: `${startFormatted} - ${endFormatted} - ${locationShort} - ${typeOrPackageShort} A-${slot.no_of_adults} K-${slot.no_of_children} ` +
                        (slot.staff_first_name || slot.staff_last_name
                            ? `Co- ${slot.staff_first_name}` : ''),
                      
                        start: startTime.toISOString(),
                        end: endTime.toISOString(),
                        description: `${slot.game_name} - ${typeOrPackageName} at ${slot.location_name}`,
                        className: className + (isSameDay ? ' same-day-booking' : ''),
                        backgroundColor: isSameDay ? '#ff3333' : eventColor, // Light red for same-day bookings
                        borderColor: isSameDay ? '#ff0000' : eventColor,     // Optional: set border color to match
                        textColor: '#FFFFFF',   
                        extendedProps: {
                            booked_date: slot.booked_date,
                            location_name: slot.location_name,
                            game_type_name: slot.game_type_name,
                            package_name: slot.package_name,
                            game_name: slot.game_name,
                            booked_time: bookingTimes.join(', '),
                            no_of_adults: slot.no_of_adults,
                            no_of_children: slot.no_of_children,
                            firstname: slot.firstname, // Add customer first name
                            lastname: slot.lastname,  // Add customer last name
                            email: slot.email,        // Add customer email
                            phone: slot.phone,
                            start_time: startFormatted, // Start time
                            end_time: endFormatted,
                            birthday_kid_name: slot.birthday_kid_name,
                            food_details: slot.food_details,
                            drink_details: slot.drink_details,
                            amount_paid: slot.amount_paid,
                           game_package_name: slot.game_package_name,
                           booking_id: slot.booking_id,
                        }
                    };

                    return formattedEvent;
                });
             
                setEvents(formattedEvents);
                setIsLoading(false);
            }
            else if (res.data.status === 404) {
                setEvents([]);
                setIsLoading(false);
            }
  
           
        });

    }



    const handleEventClick = ({ event }) => {
     
        if (event.extendedProps) {
            setBookingDetails(event.extendedProps);
          //  console.log(event.extendedProps);
            setView('details');
        } else {
           // console.log('No details found in event extendedProps');
        }
    };

    function renderEventContent(eventInfo) {
        const { event } = eventInfo;
        
        const backgroundColor = event.backgroundColor || '#03a9f3'; // Default color
    
        return (
            <div
                style={{
                    backgroundColor,
                    color: event.textColor || '#ffffff',
                    padding: '6px',
                    borderRadius: '5px',
                    textAlign: 'left',
                    width: '100%',
                    boxSizing: 'border-box',
                    overflowWrap: 'break-word', 
                    whiteSpace: 'normal', 
                    
                    
                }}
            >
                {event.title}
            </div>
        );
    }

  const handlePrevDate = () => {
  const prev = new Date(selectedDate);
  prev.setDate(prev.getDate() - 1);
  setSelectedDate(prev.toISOString().split('T')[0]);
};

const handleNextDate = () => {
  const next = new Date(selectedDate);
  next.setDate(next.getDate() + 1);
  setSelectedDate(next.toISOString().split('T')[0]);
};


const handlePrevCourt = () => {
  setStartIndex(prev => Math.max(prev - itemsPerPage, 0));
};

const handleNextCourt = () => {
  if (startIndex + itemsPerPage < game_types.length) {
    setStartIndex(prev => prev + itemsPerPage);
  }
};

    
    return (
        <div>
            <SideNav />
            <TopBar />
            {isLoading ?
                <div className="loader-container" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: "0", left: "0", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "9999" }}>
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                        </div>
                    </div>
                </div> : null}

            <div className="right_panel position contact_section vh-100" id="right_panel">
                <div className="main_title d-flex align-items-center">
                    <h1><i className="bi bi-calendar-check"></i> Manual Booking</h1>
                </div>

                <div className="content_wrapper pt-0">
                    <div className="vm_content_box_1">
                        {/* <div className="title">
                            <h2>Booking details</h2>
                        </div> */}
                        <div className='row px-4'>


                            <div class="content col-md-2">
                                <div class="form-group pt-3 pb-2">
                              <label>Location</label>
                                    <select class="form-select" id="selectedGameLocation" name="selectedGameLocation" value={selectedGameLocation} onChange={handleGameAvailableLocationChange}>
                                        <option value="">Select game location</option>
                                        {/* <option value="all">All</option> */}
                                        {filteredLocations.map((location) => (
                                            <option key={location.id} value={location.id}>
                                                {location.location_name}
                                            </option>
                                        ))}
                                    </select>   {!selectedGameLocation && (
                                        <span class="text-danger">{error_list.location_id}</span>)}
                                </div>
                            </div>

                       
                            <div class="content col-md-2 ">
                                <div class="form-group pt-3 pb-2">
        <label>Game</label>
                                    <select className="form-select me-2" id="game" name="game" value={selectedGame} onChange={handleGameChange}>
                                        <option value="">Select a game</option>
                                        {game_available.map((game) => (
                                            <option key={game.id} value={game.id}>
                                                {game.name}
                                            </option>
                                        ))}
                                    </select> {!selectedGame && (
                                        <span class="text-danger">{error_list.game_id}</span>)}
                                </div>
                            </div>

<div className="col-12 col-md-auto">

 <div className="form-group pt-3 pb-2">
    <label>Date</label>
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
  
  {/* Prev Button */}
  <button
    className="btn btn-sm btn_secondary text-white"
    onClick={handlePrevDate}
    title="Previous Date"
  
  >
    <i className="fc-icon fc-icon-chevron-left"></i>
  </button>

  {/* Date Picker */}
    <div class="form-group py-2">
  <input
    type="date"
    className="form-control"
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
   style={{ width: "100%", height: "36px" }} 
  />
</div>
  {/* Next Button */}
  <button
    className="btn btn-sm btn_secondary text-white"
    onClick={handleNextDate}
    title="Next Date"
 
  >
    <i className="fc-icon fc-icon-chevron-right"></i>
  </button>
</div>
    </div>
    </div>

  <div class="content col-md-2 ">
   <div class="form-group pt-3 pb-2">
      <label>Start Time</label>
    <input
      type="time"
      className="form-control"
      value={selectedStartTime}
      onChange={(e) => setSelectedStartTime(e.target.value)}
      title="Start Time"
      aria-label="Start Time"
    />
  </div>
    </div>

  {/* End Time Filter */}
 <div class="content col-md-2 ">
  <div class="form-group pt-3 pb-2">
      <label>End Time</label>
    <input
      type="time"
      className="form-control"
      value={selectedEndTime}
      onChange={(e) => setSelectedEndTime(e.target.value)}
        title="End Time"
      aria-label="End Time"
    />
  </div>
    </div>

                        </div>
                

                    </div>

                            <div className='row'>
                            <div className='col'>
                                <div className="content pt-3 pb-5 mb-5 " id="calender" style={{ boxShadow: "0px 0px 21px 2px rgba(0, 0, 0, 0.18)", backgroundColor: "white", marginTop: "20px", width: '100%',height:"100vh" }}  >


                             
  <div className="d-flex justify-content-between align-items-center px-3 py-3">
    
    {/* Left Arrow */}
    <button className="btn btn-sm btn_secondary text-white" onClick={handlePrevCourt}>
      <i className="fc-icon fc-icon-chevron-left"></i>
    </button>

    {/* Court Buttons */}
    <div className="d-flex gap-2 flex-wrap justify-content-center">
      {visibleCourts.map((court, index) => (
        <button
          key={index}
          className={`btn ${selectedGameType === court ? 'btn-btn btn-sm btn_secondary text-white' : 'btn-btn btn-sm btn_secondary text-whiteoutline-primary'}`}
       
          onClick={() => {
  setSelectedGameType(court.id);
  fetchTimeSlots(court.id);
}}
        >
          {court.game_type_name}
        </button>
      ))}
    </div>

    {/* Right Arrow */}
    <button className="btn btn-sm btn_secondary text-white" onClick={handleNextCourt}>
      <i className="fc-icon fc-icon-chevron-right"></i>
    </button>
  </div>

<div className="border border-bottom-0 py-0 bg-white px-3 py-3  " >
{selectedGameType && 
<div className="row mt-3">
<div className="col-md-4 d-flex justify-content-center">
  
                                                        <div className="form-group ">
                                                            {/* <label htmlFor="booking_time">Select Time:</label> */}
                                                            <div id="booking_time" className="form-control py-3" >
                                                           
                                                                        
                                                                {timeSlotLoading ? (
                                                                    <div>Loading...</div>
                                                                ) : (


                                                                    bookingAvailableTimeSlots
                                                                    .map((timeSlot, index) => {
                                                                        const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                         const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
                                                                                                                         
                                                          
                                                                         let isDisabled = Array.isArray(disabledTimeSlots) && disabledTimeSlots.includes(timeSlot) ;
                                                                
                                                                       // Handle specific logic for "Private" game type
                                                                        // if (game_type && game_type.game_type_name.toLowerCase().includes('private')) {
                                                                        //     // Disable slots that do not have exactly max players available
                                                                        //     if (remainingSpace !== game_type.max_players_in_a_slot) {
                                                                        //         isDisabled = true;
                                                                        //     }
                                                                        // }
                                                                       

                                                                        // Handle specific logic for "Birthday Package"
                                                                        // if (selectedPackageType === 'birthday_package' && game_packages.length > 0) {
                                                                        //     const maxPlayers = game_packages[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                        
                                                                        //     // Check if the current slot has enough availability for the package requirement
                                                                        //     const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                        //     const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                        
                                                                        //     // Disable the slot if it doesn't have the required player availability
                                                                        //     if (remainingSpace !== maxPlayers) {
                                                                        //         isDisabled = true;
                                                                        //     }
                                                                            
                                                                        // }

                                                                        // if (selectedPackageType === 'corporate_event' && corporate_events.length > 0) {
                                                                        //     const maxPlayers = corporate_events[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                        
                                                                        //     // Check if the current slot has enough availability for the package requirement
                                                                        //     const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                        //     const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                        
                                                                        //     // Disable the slot if it doesn't have the required player availability
                                                                        //     if (remainingSpace !== maxPlayers) {
                                                                        //         isDisabled = true;
                                                                        //     }
                                                                        // }
                                                                        
                                                                       
                                                                        // const currentTime = dayjs(); // Get current system time
                                                                        // const slotStartTimeString = timeSlot.split(" - ")[0]; // Extract "04:30 PM" from "04:30 PM - 05:00 PM"
                                                                        // const slotStartTime = dayjs(slotStartTimeString, "hh:mm A", true); // Parse correctly
                                                                        
                                                                        // if (!slotStartTime.isValid()) {
                                                                        //   console.error("Invalid time format:", slotStartTimeString);
                                                                        // }
                                                                        
                                                                        // // Disable slots that have already passed for today
                                                                        // if (dayjs(selectedDate).isSame(dayjs(), "day") && slotStartTime.isValid() && slotStartTime.isBefore(currentTime)) {
                                                                        //   isDisabled = true;
                                                                        // }
                                                                    //  console.log(currentTime,timeSlot)
                                                                    return (
    <div key={index} style={{ width: '100%' }}>
      {/* Time slot row */}
      <div
        className="form-group-checkbox d-flex align-items-center justify-content-between"
        style={
          isDisabled
            ? {
                backgroundColor: 'rgb(255, 204, 204)',
                pointerEvents: 'none',
                margin: '0 -15px',
                padding: '2px 15px',
              }
            : {
                margin: '0 -15px',
                padding: '2px 15px',
              }
        }
      >
        {/* Left: Clock + Time */}
        <div className="d-flex align-items-center">
          <i className="bi bi-clock me-2" style={{ fontSize: '10px' }}></i>
          <label htmlFor={`timeslot_${index}`} className="mb-0 mt-2">
            {timeSlot}    
          </label>
        </div>
        
        <div style={{ marginLeft: '20px'}}>
    ${timeSlotDetails.court_price.toFixed(2)}
  </div>


        {/* Right: Reset icon if disabled */}
        {isDisabled ? (
          <span
            title="Reset"
            style={{
              cursor: 'pointer',
              fontSize: '14px',
              color: '#333',
              marginLeft: '20px',
            }}
          >
            ⟲
          </span>
        ) :  <span
            title="Reset"
            style={{
              cursor: 'pointer',
              fontSize: '14px',
              color: '#333',
              marginLeft: '20px',
              visibility:'hidden',
            }}
          >
        ⟲
          </span> }
      </div>

      {/* Divider */}
      {index !== bookingAvailableTimeSlots.length - 1 && (
        <hr
          className="my-0"
          style={{
            borderTop: '1px solid rgb(71, 71, 71)',
            margin: '0 -15px',
          }}
        />
      )}
    </div>
  );

      })
                                                                


                                                                )}
                                                               
                                                            </div>
                                                     
                                                        </div>
                                                    </div>
  {/* {IsWaitingList && (
                                                     <div className="col-md-4">
      <div className="card shadow-sm p-3">
        <h5>Card 2</h5>
        <p>This appears on button click.</p>
      </div>
    </div>
  )}

    <div className="col-md-4">
      <div className="card shadow-sm p-3">
        <h5>Card 3</h5>
        <p>This is also triggered.</p>
      </div>
    </div> */}
                                                     </div>
}





</div>

                                </div>
                            </div>

                           



{view === 'details' && (
    <div className='col-md-4'>
        <div className="py-3 mt-4 border-top bg-light rounded shadow-sm">
            <h3 className="vm_font_semi_bold border-bottom mb-3 px-3 pb-2 ">
                Booking Details
            </h3>
<div className="content py-0 bg-white px-3 py-3 shadow-lg mb-3 w-100" >
            <div className="text-center">
                <h2 className="vm_font_bold mt-2">{bookingDetails.firstname} {bookingDetails.lastname}</h2>
                <div className="d-flex justify-content-center mb-3">
                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center pe-3 text-decoration-none text-dark">
                        <i className="bi bi-telephone-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.phone}</p>
                    </a>

                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center text-decoration-none text-dark">
                        <i className="bi bi-envelope-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.email}</p>
                    </a>
                </div>
            </div>

            <div className="row border-top pb-3">
                {[
                    { label: 'Game Name', value: bookingDetails.game_name },
                    { label: 'Location', value: bookingDetails.location_name },
                    { label: 'Game Package', value: bookingDetails.game_type_name ? bookingDetails.game_type_name : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}` },
                    { label: 'Booked Date', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-calendar3 me-2 text-success" ></i>
                            <span>{moment(bookingDetails.booked_date).format('D MMMM YYYY')}</span>
                        </div>
                    ) },
                    { label: 'Booked Time', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-clock-fill me-2 text-success" ></i>
                            <span>{bookingDetails.start_time} - {bookingDetails.end_time}</span>
                        </div>
                    ) },
                    { label: 'Adult Count', value: bookingDetails.no_of_adults },
                    { label: 'Kids Count', value: bookingDetails.no_of_children },
                    { label: 'Amount paid', value: bookingDetails.amount_paid },
                    
                    ...(bookingDetails.package_name 
                        ? [
                          
                            { label: 'Birthday Kid Name', value: bookingDetails.birthday_kid_name },
                          

                                ...(bookingDetails.food_details
                                    ? [{
                                        label: 'Food details',
                                        value: Object.entries(JSON.parse(bookingDetails.food_details || "{}"))
                                        .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                        .join(", ")  // Join with ", " for proper display
                                  }]
                                    : []),

                                    ...(bookingDetails.drink_details
                                        ? [{
                                            label: 'Drink details',
                                            value: Object.entries(JSON.parse(bookingDetails.drink_details || "{}"))
                                            .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                            .join(", ")  // Join with ", " for proper display
                                      }]
                                        : []),
                              

                        ]
                        : [])
                  

                ].map((detail, index) => (
                    <div className="d-flex border-bottom py-2" key={index}>
                        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
                        <div className="col-7 p-1 ps-3">{detail.value}</div>
                    </div>
                ))}
          
   <div class="d-flex justify-content-center pt-3 ">
<button class="btn btn-sm btn_secondary"  onClick={() => handleViewBookings(bookingDetails.booking_id)}  >
View More Details</button>
</div>

            </div>
        </div>
    </div>
    </div>
)}

 </div>

                </div>












                
            </div>











        </div>
    );
}

export default ViewAllBookings;
